var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.convenio.idSituacaoConvenio != 9)?_c('span',{staticClass:"text-succes float-left mr-1"},[_c('i',{staticClass:"fa fa-retweet fa-lg icon-button",attrs:{"title":"Resetar Situação da Prestação"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarReset(_vm.prestacaoContasFinalLancamento.idPrestacaoContasFinal)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }